import PlayerMoveAlert from './PlayerMoveAlert'

export default PlayerMoveAlert
